const HisShieldCheck = ({ color, sx }) => {
  const strokeColor = color ?? "#0B4EDB";
  const _sx = sx ?? {};
  return (
    <svg
      style={_sx}
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8457 29.8423C16.8457 29.8423 27.5137 24.5083 27.5137 16.5073V7.17285L16.8457 3.17236L6.17773 7.17285V16.5073C6.17773 24.5083 16.8457 29.8423 16.8457 29.8423Z"
        stroke={strokeColor}
        strokeWidth="2.66699"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8452 16.5073L15.5122 19.1743L20.8462 13.8403"
        stroke={strokeColor}
        strokeWidth="2.66699"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisShieldCheck;
